<template>
  <div class="grey lighten-4 text-right pa-4">
    <span class="mx-4">Tổng tiền chi trả</span>
    <span v-if="!loadingFee" class="red--text mx-4"> {{ totalFee ? totalFee.toLocaleString('en-US') : 0 }} VNĐ </span>
    <!-- <span class="mr-2 detail_text" @click="setToggleFilter" v-if="!loadingFee">
      <router-link to="/salary-stat-report" class="text-decoration-none font-weight-bold">
        Xem chi tiết
      </router-link>
    </span> -->
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      totalFee: 'salaryPeriod/totalFee',
      loadingFee: 'salaryPeriod/loadingFee',
      toggleFilter: 'salaryReport/toggleFilter',
      detailPeriod: 'salaryPeriod/detailPeriod'
    })
  },
  methods: {
    ...mapMutations('salaryReport', ['setToggleFilter'])
  }
}
</script>
<style lang="scss">
.detail_text {
  font-size: 14px;
  color: #0d47a1;
}
</style>
